export default __webpack_public_path__ + "static/media/btn-zeroback-start-it_it@3x.08b27a20.png";